import { Route } from '@model/iceberg';

export enum Airlines {
  RYAN_AIR = 'Ryanair'
}

export const isRyanAirFlight = ({ airline }: Route) => airline === Airlines.RYAN_AIR;

export const hasRyanairFlight = (routes: Array<Route>) => routes.some(isRyanAirFlight);
